module.exports = __webpack_public_path__ + "media/images/tokyo_tour_th01-1ef41ef2d176a7cb148d0fd00f9f8dd7.jpg";